<template>
<div class="messages">

    <InvestorBody>
		<h1>Messages</h1>

		<div v-if="createTicket">

            <CreateTicketMenu @previous="previousClick"></CreateTicketMenu>

        </div>
        <div v-else>

            <div class="messages-buttons">
                <span @click="addClick">
                    <i class="icon icon-square-edit"></i>
                </span>
                <span @click="refreshSupportTickets">
                    <i class="icon icon-refresh"></i>
                </span>
            </div>

            <Ticket :ticket="ticket" v-for="ticket in supportTickets" :key="ticket.ticket_id"></Ticket>

            <Pagination :count="supportTicketsCount" :currentPage.sync="currentPage" :itemsPerPage="itemsPerPage"></Pagination>
        </div>
        
    </InvestorBody>

</div>
</template>

<script>
import {
    mapGetters
} from "vuex";
import store from "@/store";
import Pagination from '@/../submodules/vue-base/components/Pagination';
import Ticket from "@/components/support/Ticket";
import CreateTicketMenu from "@/components/support/CreateTicketMenu";
import Cover from "../components/layout/Cover.vue";
import InvestorBody from "../components/layout/InvestorBody.vue";

export default {
    name: "Messages",

    data() {
        return {
            itemsPerPage: 20,
            currentPage: 1,
            createTicket: false
        }
    },

    components: {
        Pagination,
        Ticket,
        CreateTicketMenu,
        Cover,
        InvestorBody
    },

    beforeRouteEnter(to, from, next) {
        var page = 1;
        var obj = {
            offset: (page - 1) * 20,
            limit: 20,
            type: "investor"
        }
        if (store.state.user.user.is_investor) {
            store.dispatch("updateQuery", obj);
            store.dispatch("loadInvestorSupportTickets").then(function () {
                next();
            });
			store.dispatch("loadInvestorUnreadTickets");
        } else {
            next();
        }
    },

    beforeRouteUpdate(to, from, next) {
        var page = 1;
        var obj = {
            offset: (page - 1) * 20,
            limit: 20,
            type: "investor"
        }
        if (store.state.user.user.is_investor) {
            store.dispatch("updateQuery", obj);
            store.dispatch("loadInvestorSupportTickets").then(function () {
                next();
            });
        } else {
            next();
        }
    },

    methods: {
        refreshSupportTickets() {
            var obj = {
                offset: (this.currentPage - 1) * 20,
                limit: 20,
                type: "investor"
            }
            this.$store.dispatch("updateQuery", obj);
            this.$store.dispatch("loadInvestorSupportTickets");
			this.$store.dispatch("loadInvestorUnreadTickets");
        },
        addClick() {
            this.createTicket = true;
        },
        previousClick() {
            this.createTicket = false;
        },
    },

    watch: {
        currentPage() {
            var obj = {
                offset: this.itemsPerPage * (this.currentPage - 1),
                limit: this.itemsPerPage,
                type: "investor"
            }
            store.dispatch("updateQuery", obj);
            store.dispatch("loadInvestorSupportTickets");
        }
    },

    computed: {
        ...mapGetters(["supportTickets", "supportTicketsCount"])
    },
};
</script>
